import { addLateDibsSessionHandler } from 'dibs-cookie-jar/exports/dibsSession.ts';
import serverVars from 'server-vars';
import { datadog } from '../datadog.ts';
import { setDatadogSessionValues } from './setDatadogValues.ts';

// Only the consent-gated keys change on a late grant. Shared by buyer and dealer pages, so it must
// not call setUser: dealer RUM sets the seller as the user.
const publishDibsSessionToDatadog = (): void => {
    if (!serverVars.get('DD_RUM')) {
        return;
    }
    datadog.load().then((rum): void => {
        if (rum) {
            setDatadogSessionValues(rum);
        }
    });
};

export function registerLateDibsSessionDatadog(): void {
    addLateDibsSessionHandler(publishDibsSessionToDatadog);
}

registerLateDibsSessionDatadog();
